import { combineSx, createSvgIcon, SvgIconProps } from '@chronosphereio/chrono-ui';

const IconBase = createSvgIcon(
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="9" y1="8" x2="22.5" y2="15.5" className="line-fill" stroke="currentColor" strokeWidth="1.5" />
    <line x1="9" y1="24" x2="22.5" y2="16.5" className="line-fill" stroke="currentColor" strokeWidth="1.5" />
    <line x1="9" y1="16" x2="22" y2="16" className="line-fill" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="7" cy="8" r="3" className="circle-fill" fill="currentColor" />
    <circle cx="7" cy="16" r="3" className="circle-fill" fill="currentColor" />
    <circle cx="7" cy="24" r="3" className="circle-fill" fill="currentColor" />
    <circle cx="25" cy="16" r="3" className="circle-fill" fill="currentColor" />
  </svg>,
  'NodeGraphIcon'
);

export const NodeGraphIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <IconBase
      {...props}
      sx={combineSx(
        (theme) => ({
          '.line-fill': {
            color: theme.palette.status.success.main,
            stroke: theme.palette.status.success.main,
          },
          '.circle-fill': {
            color: theme.palette.status.success.highContrast,
          },
        }),
        sx
      )}
    />
  );
};
